import angular from 'angular';

/* @ngInject */
class Layout {
	constructor(PageHeaderService, $rootScope) {
		this.PageHeaderService = PageHeaderService;
		this.$rootScope        = $rootScope;

		this.title = null;
	}

	setTitle(title, pageHeader) {
		this.title = title;

		this.fireUpdatedEvent();

		if (pageHeader == undefined || pageHeader == true) {
			if (angular.isArray(title)) {
				title = title[0];
			}

			this.PageHeaderService.setTitle(title);
		}

		return this;
	};

	getTitle() {
		return this.title;
	};

	getPageHeader() {
		return this.PageHeaderService;
	};

	fireUpdatedEvent() {
		this.$rootScope.$broadcast('layoutService.updated');
	};

	onUpdated(callback) {
		this.$rootScope.$on('layoutService.updated', callback);
	};

	reset() {
		this.title = null;
		this.getPageHeader()
		    .reset();

		this.fireUpdatedEvent();
	};
}

export default Layout;


// WEBPACK FOOTER //
// ./src/js/services/layout/index.js